// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2P-S-","radioRow":"SimpleQuestionBuilderModal_radioRow__2IzYl"};